import { FormCard, FormItem, MultiSelect } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useGroupedCarers } from 'hooks/useGroupedOptions'
import { useTranslation } from 'react-i18next'
import type { ModalSectionProps } from '../utils'

export const AllocationStep = ({ formData }: ModalSectionProps) => {
  const { t } = useTranslation()
  const { groupedCarerOptions } = useGroupedCarers()

  const teamMembersCount = formData?.teamMembers?.length ?? 0
  const maxTeamMembers = formData?.numberSupply ?? 0

  return (
    <FormCard level={2} title={t('ASSIGN_TEAM_MEMBER')}>
      <Text>{t('ASSIGN_TEAM_MEMBER_DESCRIPTION')}</Text>
      <FormItem
        name="teamMembers"
        label={<Text>{t('TEAM_MEMBER(S)')}</Text>}
        short
      >
        <MultiSelect
          title={t('SELECT_TEAM_MEMBERS')}
          groupedOptions={groupedCarerOptions}
          hasClear
          hasSearch
          hasSelectAll
          placeholder
          maxTagCount={null}
          values={formData?.teamMembers || []}
          suffixIcon={
            <Text>
              {teamMembersCount}/{maxTeamMembers}
            </Text>
          }
        />
      </FormItem>
    </FormCard>
  )
}
